import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";

/**
 * Lightweight transition wipe on route change.
 * Slides up a red panel across the screen while the new page mounts.
 */
export const RouteTransition = () => {
  const location = useLocation();
  const { lang } = useLang();
  const [active, setActive] = useState(false);
  const [label, setLabel] = useState("");
  const prevPath = useState({ current: location.pathname })[0];

  useEffect(() => {
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;
    const seg = location.pathname.replace("/", "") || "home";
    const map = {
      en: { home: "Home", track: "Track", fleet: "Fleet", pricing: "Pricing", experience: "Experience", gallery: "Gallery", faq: "FAQ", contact: "Contact", booking: "Booking" },
      bg: { home: "Начало", track: "Пистата", fleet: "Картове", pricing: "Цени", experience: "Преживяване", gallery: "Галерия", faq: "Въпроси", contact: "Контакти", booking: "Резервация" },
    };
    setLabel(map[lang][seg] || seg);
    setActive(true);
    const id = setTimeout(() => setActive(false), 700);
    return () => clearTimeout(id);
  }, [location.pathname, lang, prevPath]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: "0%" }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.7, ease: [0.85, 0, 0.15, 1] }}
          className="fixed inset-0 z-[90] pointer-events-none flex items-center justify-center bg-[#FF2D2D]"
          data-testid="route-transition"
        >
          <div className="absolute inset-x-0 top-0 h-6 checker opacity-30" />
          <div className="absolute inset-x-0 bottom-0 h-6 checker opacity-30" />
          <h2 className="font-display text-6xl md:text-8xl font-bold uppercase tracking-tighter text-white">
            / {label}
          </h2>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RouteTransition;
